// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f7c1e3a7","404":"a17e1c92","498":"49cda330"}[chunkId] + ".chunk.js";
};